module.exports = __webpack_public_path__ + "img/bg-ellipse-2.a7d0e83d.svg";